import styled from 'styled-components';
import { Controller, useForm } from 'react-hook-form';
import { useState } from 'react';
import Select from 'react-select';
import { addressCollection } from '../../utils/address';

const companyName = [
  {
    value: '기사',
    label: '기사',
  },
  {
    value: '회사',
    label: '회사',
  },
];

interface AdminSearchComponentProps {
  handleSearchChange: (searchParams: any) => void;
  searchType?: string | null;
}

export const AdminSearchComponent = ({
  handleSearchChange,
  searchType = null,
}: AdminSearchComponentProps) => {
  const { register, handleSubmit, control, reset } = useForm();

  const [selectedRegion, setSelectedRegion] = useState<{
    label: string;
    value: string;
    gu: { label: string; value: string }[];
  } | null>(null);

  const onSubmit = (data: any) => {
    console.log(data);
    let searchParams = {};

    if (searchType === 'onlyTitle') {
      searchParams = {
        title: data.searchText,
      };
    } else {
      const guValue = data.gu || '';
      searchParams = {
        memberType: data.name,
        cityProvince: data.city,
        district: guValue,
        searchTerm: data.searchText,
      };
    }

    handleSearchChange(searchParams); // 상위 컴포넌트로 검색 조건 전달
    reset({ searchText: '', name: '', city: '', gu: '' }); // 검색 완료 후 searchText 초기화
    setSelectedRegion(null); // selectedRegion 상태도 초기화
  };

  return (
    <Container>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={searchType === 'onlyTitle' ? 'only-title' : ''}
      >
        {searchType !== 'onlyTitle' ? (
          <>
            <div className="select-wrapper">
              <Controller
                name="name"
                control={control}
                render={({ field }: any) => {
                  const selectedOption =
                    companyName.find((c) => c.value === field.value) || null;

                  return (
                    <Select
                      className="search-select member-type"
                      classNamePrefix="react-select"
                      options={companyName}
                      onChange={(val) => {
                        field.onChange(val ? val.value : null);
                      }}
                      value={selectedOption}
                      components={{ IndicatorSeparator: () => null }}
                      placeholder="회원 구분"
                      maxMenuHeight={200}
                    />
                  );
                }}
              />
            </div>
            <span className="title address">회사 지역 구분</span>
            <div className="select-wrapper">
              <Controller
                name="city"
                control={control}
                render={({ field }) => (
                  <Select
                    className="search-select"
                    classNamePrefix="react-select"
                    options={addressCollection}
                    onChange={(selectedOption) => {
                      setSelectedRegion(selectedOption);
                      field.onChange(selectedOption?.value);
                    }}
                    value={selectedRegion}
                    components={{ IndicatorSeparator: () => null }}
                    placeholder="시도 선택"
                    maxMenuHeight={200}
                  />
                )}
              />
            </div>
            <div className="select-wrapper">
              <Controller
                name="gu"
                control={control}
                render={({ field }) => (
                  <Select
                    className="search-select gu"
                    classNamePrefix="react-select"
                    options={selectedRegion ? selectedRegion.gu : []}
                    onChange={(val) => {
                      field.onChange(val ? val.value : null);
                    }}
                    value={
                      selectedRegion?.gu.find((g) => g.value === field.value) ||
                      null
                    }
                    components={{ IndicatorSeparator: () => null }}
                    placeholder="구/군 선택"
                    maxMenuHeight={200}
                    isDisabled={!selectedRegion} // 시도가 선택되지 않았을 때 비활성화
                  />
                )}
              />
            </div>
          </>
        ) : null}

        <div className="input-wrapper">
          <input
            type="text"
            {...register('searchText')}
            placeholder="검색어를 입력하세요. ex.회사명"
          />
        </div>
        <input type="submit" value="검색" />
      </form>
    </Container>
  );
};

// style
const Container = styled.div`
  form {
    display: flex;
    width: 100%;
    align-items: center;
    background-color: ${(props) => props.theme.textWhiteColor};
    padding: 1.4rem 1.6rem;
    max-width: 140.9rem;
    margin: 0 auto;
    border-radius: 1.6rem;
    box-shadow: 0 4px 11.3px 0 rgba(181, 181, 181, 0.09);
    &.only-title {
      max-width: 53.4rem;
      .input-wrapper {
        width: 100%;
        max-width: none;
        margin-left: 0;
        input[type='text'] {
          padding: 1.4rem 1.8rem 1.5rem;
          border-radius: 0.8rem;
          border: 1px solid ${(props) => props.theme.searchBoxBorderedColor};
          &::placeholder {
            color: ${(props) => props.theme.searchPlaceholderColor};
          }
          width: 100%;
        }
      }
    }
    .title {
      font-size: 1.4rem;
      color: #6f6f6f;
      font-weight: 600;
      white-space: nowrap;
      &.address {
        margin-left: 9.5rem;
        margin-right: 1.2rem;
      }
    }

    .input-wrapper {
      width: 100%;
      max-width: 25rem;
      margin-left: 8.2rem;
      input[type='text'] {
        padding: 1.4rem 1.8rem 1.5rem;
        border-radius: 0.8rem;
        border: 1px solid ${(props) => props.theme.searchBoxBorderedColor};
        &::placeholder {
          color: ${(props) => props.theme.searchPlaceholderColor};
        }
        width: 100%;
      }
    }
    input[type='submit'] {
      width: 10rem;
      background-color: ${(props) => props.theme.btnBlueColor};
      color: ${(props) => props.theme.textWhiteColor};
      padding: 1.2rem;
      border-radius: 0.8rem;
      border: 0;
      outline: none;
      font-size: 1.8rem;
      font-weight: 600;
      margin-left: 1.2rem;
    }
    .search-select {
      width: 18rem;
      font-size: 1.4rem;
      .react-select__placeholder {
        color: ${(props) => props.theme.searchPlaceholderColor};
      }
      .react-select__control {
        border-color: ${(props) => props.theme.searchBoxBorderedColor};
        border-radius: 0.8rem;
        .react-select__value-container {
          padding: 1rem 1.6rem 0.9rem;
        }
      }
      &.member-type {
        width: 23.6rem;
      }
      &.gu {
        margin-left: 1.2rem;
      }
    }
  }
`;
